"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckCircle = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var CheckCircle = function CheckCircle(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon.default, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "white"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.6667 11.3V11.8367C17.666 13.0946 17.2586 14.3186 16.5054 15.3261C15.7523 16.3336 14.6936 17.0706 13.4873 17.4273C12.281 17.7839 10.9917 17.7411 9.81177 17.3052C8.63181 16.8692 7.62438 16.0636 6.93973 15.0083C6.25507 13.953 5.92988 12.7047 6.01264 11.4495C6.09541 10.1943 6.5817 8.99953 7.399 8.0433C8.21629 7.08707 9.32079 6.42065 10.5478 6.14342C11.7748 5.8662 13.0585 5.99304 14.2075 6.50501",
    fill: "none",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.6673 7.17041L11.834 13.0096L10.084 11.2596",
    fill: "none",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
exports.CheckCircle = CheckCircle;